import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Image from '@xingternal/malt-image';
import { BodyCopy } from '@xingternal/typography';
import { Button, TextButton } from '@xingternal/button';
import {
  cornerRadiusL,
  scale010,
  scale130,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXXL,
  xdlColorTextOnLight,
  xdlColorTextSecondary,
  xdlPaletteGrayPlain04,
} from '@xingternal/tokens';

import { mediaWide } from '@xingternal/layout-tokens';

const Section = styled.section`
  padding: ${spaceXXL} ${spaceL};
`;

const EmptyStateElement = styled.div`
  align-items: center;
  color: ${xdlColorTextSecondary};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 500px;
  padding: ${scale130};
  text-align: center;

  ${(props) =>
    props.variant === 'engage' &&
    css`
      border: ${scale010} solid ${xdlPaletteGrayPlain04};
      border-radius: ${cornerRadiusL};
      color: ${xdlColorTextOnLight};
      padding: ${scale130 - scale010};
    `}
`;

const StyledImage = styled(Image)`
  margin-bottom: ${spaceXL};
`;

const StyledButton = styled(Button)`
  margin-top: ${spaceS};

  @media (${mediaWide}) {
    margin-top: ${spaceXL};
  }
`;

const StyledSecondaryButton = styled(TextButton)`
  margin-top: ${spaceM};
`;

const EmptyState = ({
  title,
  subtitle,
  icon,
  button,
  secondaryButton,
  className,
  variant,
}) => {
  return (
    <Section className={className}>
      <EmptyStateElement variant={variant}>
        <StyledImage src={icon} alt={title} />
        <BodyCopy>{title}</BodyCopy>
        {subtitle && <BodyCopy>{subtitle}</BodyCopy>}
        {button && (
          <StyledButton variant="secondary" size="medium" {...button} />
        )}
        {secondaryButton && (
          <StyledSecondaryButton size="small" {...secondaryButton} />
        )}
      </EmptyStateElement>
    </Section>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  button: PropTypes.shape({
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    type: PropTypes.string,
  }),
  secondaryButton: PropTypes.shape({
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
  }),
  className: PropTypes.string,
  variant: PropTypes.string,
};

export default EmptyState;
